import { apiFetch, API_BASE } from './api';

// #3704 — the Claude Design export calls, shared by the Screen Specifications artefact page
// (ArtefactDetailContent) and the chat's Claude Design card, so the two can never drift.
// The ZIP needs the bearer token from localStorage (a plain link cannot carry it), so it is
// fetched and saved as a blob.

/** Downloads `<fileBase>-claude-design.zip`. Throws with the server's message on failure. */
export async function downloadClaudeDesignZip(projectId: string, fileBase: string): Promise<void> {
  const token = localStorage.getItem('blueprint_token');
  const res = await fetch(`${API_BASE}/projects/${projectId}/claude-design/export/zip`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
    credentials: 'include',
  });
  if (!res.ok) {
    const body = (await res.json().catch(() => ({}))) as { error?: string };
    throw new Error(body.error || `Export failed: HTTP ${res.status}`);
  }
  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `${fileBase.replace(/[^a-z0-9-]+/gi, '-').toLowerCase() || 'project'}-claude-design.zip`;
  a.click();
  // R3 P3-6 — revoke after the download has started, not synchronously (a synchronous revoke can
  // cancel the download in some browsers).
  setTimeout(() => URL.revokeObjectURL(url), REVOKE_AFTER_MS);
}

/** How long the blob URL stays valid after the download is started. */
export const REVOKE_AFTER_MS = 10_000;

/** The export's PROMPT.md, for Copy PROMPT.md. */
export async function fetchClaudeDesignPrompt(projectId: string): Promise<string> {
  const res = await apiFetch<{ bundle: { promptMd: string } }>(
    `/projects/${projectId}/claude-design/export`,
    { method: 'POST', body: JSON.stringify({}) },
  );
  return res.bundle.promptMd;
}
